import * as constants from "./constants";

export const fetchAllCallHistories = (payload) => ({
  type: constants.FETCH_ALL_CALL_HISTORIES,
  payload,
});

export const fetchAllCallHistoriesSuccess = (data) => ({
  type: constants.FETCH_ALL_CALL_HISTORIES_SUCCESS,
  data,
});

export const fetchAllCallHistoriesError = (error) => ({
  type: constants.FETCH_ALL_CALL_HISTORIES_ERROR,
  error,
});
